var _class, _descriptor, _descriptor2;
function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }
function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'proposal-class-properties is enabled and runs after the decorators transform.'); }
import { A } from '@ember/array';
import { setProperties } from '@ember/object';
import Route from '@ember/routing/route';
import { inject as service } from '@ember/service';
import uniqBy from 'lodash/uniqBy';
import { RoomsOrderBy, SortDirection } from 'roomba/graphql/generated/graphql-types';
export const ROOMS_UNASSIGNED_AT_CURRENT_LOCATION_PER_PAGE = 200;
let RoombaSettingsCalendarsRoute = (_class = class RoombaSettingsCalendarsRoute extends Route {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "graphql", _descriptor, this);
    _initializerDefineProperty(this, "state", _descriptor2, this);
  }
  setupController(controller, model, transition) {
    super.setupController(controller, model, transition);
    setProperties(controller, {
      selectedUnassignedRooms: A(),
      selectedAssignedRooms: A(),
      rooms: model.rooms,
      totalRoomsCount: model.totalCount,
      unassignedRoomsTotalCount: model.unassignedRoomsCount,
      assignedRoomsTotalCount: model.assignedRoomsCount
    });
  }
  async model() {
    const {
      currentLocation
    } = this.state;
    if (!currentLocation) {
      throw new Error('no current location found while loading roomba settings');
    }
    const sort = {
      by: RoomsOrderBy.DisplayName,
      direction: SortDirection.Asc
    };
    const filter = {
      locationId: {
        _neq: currentLocation.id,
        _eq: null,
        _in: null,
        _is_null: null,
        _nin: null
      },
      buildingId: null,
      buildingName: null,
      displayName: null,
      floorName: null
    };
    const pagination = {
      limit: ROOMS_UNASSIGNED_AT_CURRENT_LOCATION_PER_PAGE,
      offset: 0
    };
    const {
      items: rooms,
      totalCount: unassignedAtCurrentLocationTotalRoomsCount
    } = await this.graphql.getRoomsPaginated(filter, sort, pagination);
    const filterAssignedRooms = {
      locationId: {
        _eq: currentLocation.id,
        _neq: null,
        _in: null,
        _is_null: null,
        _nin: null
      },
      buildingId: null,
      buildingName: null,
      displayName: null,
      floorName: null
    };
    const {
      items: roomsAssignedToCurrentLocation,
      totalCount: assignedAtCurrentLocationTotalRoomsCount
    } = await this.graphql.getRoomsPaginated(filterAssignedRooms, sort);
    return {
      rooms: uniqBy([...rooms, ...roomsAssignedToCurrentLocation], 'id'),
      totalCount: unassignedAtCurrentLocationTotalRoomsCount + roomsAssignedToCurrentLocation.length,
      unassignedRoomsCount: unassignedAtCurrentLocationTotalRoomsCount,
      assignedRoomsCount: assignedAtCurrentLocationTotalRoomsCount
    };
  }
}, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "graphql", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "state", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
})), _class);
export { RoombaSettingsCalendarsRoute as default };